module.exports = __webpack_public_path__ + "static/media/caret-right-fill.4617c767.svg";